export default "__VITE_ASSET__BmGfKgiP__"